export const normalizeTubularTypeValue = (str: string | undefined | null): string =>
    str ? str.replace(/\s+/g, '_').toUpperCase() : ''

export const transformConfigIntoStringInJSONFormat = (config: any): string => {
    return JSON.stringify(JSON.parse(JSON.stringify(config)), null, 2)
}

export function getFormattedGoalLabel(goal) {
    if (!goal?.attributes) return ''
    const formattedLabels = goal.attributes.map((attr, idx) => {
        if (attr.acronym === 'NA' || attr.acronym === 'UN') return ''

        // macro
        if (idx === 0) return ` - ${attr.title} `

        if (idx === 1 || idx === 2 || idx === 5 || idx === 6 || idx === 8 || idx === 9) return `- ${attr.title} `

        // stand size
        if (idx === 3) {
            const explodedWords = attr.title.split(' ')

            return `- ${explodedWords[0]} `
        }

        // tubular/section OD
        if (idx === 4) {
            if (!attr?.inputs?.tubularInputValues) return ''
            const min = attr.inputs.tubularInputValues.find(i => i.key === 'Y')
            const max = attr.inputs.tubularInputValues.find(i => i.key === 'X')
            if (!isNaN(min.value) && !isNaN(max.value)) return `- >=${min.value}to${max.value}<= `
            if (!isNaN(min.value)) return `- >=${min.value} `
            if (!isNaN(min.value) && !isNaN(max.value)) return `- ${max.value}<= `
        }

        // restricted performance
        if (idx === 7) {
            if (attr.acronym === 'RXyyy') {
                return '- Performance Multiple Options '
            } else {
                return `- Performance ${attr.title} `
            }
        }
    })

    const macro = formattedLabels[0]
    const tubularActivites = formattedLabels[1]
    const kpi = formattedLabels[2]
    const standSize = formattedLabels[3]
    const OD = formattedLabels[4]
    const movementDirection = formattedLabels[5]
    const sectionHoleStatus = formattedLabels[6]
    const restrictedPerformance = formattedLabels[7]
    const materialType = formattedLabels[8]
    const connectionType = formattedLabels[9]

    return (
        macro +
        kpi +
        restrictedPerformance +
        standSize +
        movementDirection +
        OD +
        materialType +
        connectionType +
        sectionHoleStatus
    )
}

export const generateRestrictedGoalValue = (
    restrictedValueUom: ValueUom,
    restrictedAcronym?: string
): {
    label: string
    value: ValueUom | string
} => {
    let restrictedGoalValue = {
        label: '' as string,
        value: '' as ValueUom | string
    }

    if (restrictedValueUom?.value) {
        restrictedGoalValue = {
            label: `${restrictedValueUom.value} ${restrictedValueUom?.uom?.name ??
                restrictedValueUom?.name ??
                ''}${restrictedAcronym ??
                restrictedValueUom?.speedAcronym ??
                restrictedValueUom?.timeConnectionAcronym ??
                restrictedValueUom?.ropSpeed ??
                ''}`,
            value: restrictedValueUom
        }
    }

    return restrictedGoalValue
}

export const someExpandedRows = (expandedRowKeys: ExpandedRowKeys): boolean => {
    return Object.values(expandedRowKeys).some(entityExpandedRows => entityExpandedRows.length > 0)
}
